import { Box, Card, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { currencyFormatter } from '../../utils'
import OrderHistorySubProducts from './OrderHistorySubProducts'
import { LineItem } from '../../models/order-history-detail.model'

interface OrderHistoryProductsProps {
  name: string
  quantity: number
  price: number
  subProducts: LineItem[]
}

const useStyles = makeStyles()(theme => ({
  container: {
    marginTop: theme.spacing(2),
  },

  orderDetailsWrapper: {
    paddingBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    backgroundColor: theme.palette.background.paper2,
    marginBottom: theme.spacing(3),
  },
  productContainer: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  productMainInfoContainer: {
    display: 'flex',
    gap: theme.spacing(3),
    flex: 1,
    justifyContent: 'space-between',
    width: '60%',
    maxWidth: '60%',
  },
  textSpace: {
    marginBottom: theme.spacing(1),
  },
  productFixFlexContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(3),
  },
  textEllipsis: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '500px',
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      width: '250px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100px',
    },
  },
}))

const QUANTITY_SYMBOL = 'x'

/*
 * This component render the products into order history details modal
 */
const OrderHistoryProducts: React.FC<OrderHistoryProductsProps> = ({ name, quantity, price, subProducts }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const formattedPrice = currencyFormatter(price)
  return (
    <Box className={classes.container}>
      <Card className={classes.orderDetailsWrapper}>
        <Box className={classes.productContainer}>
          <Box className={classes.productMainInfoContainer}>
            <Box>
              <Typography variant="body2" className={classes.textSpace}>
                {t('shop.order-history.product-name-label')}
              </Typography>
              <Typography variant="h3" className={classes.textEllipsis}>
                {name}
              </Typography>
            </Box>
            <Box>
              <Typography variant="body2" className={classes.textSpace}>
                {t('shop.order-history.product-number-label')}
              </Typography>
              <Typography variant="h3">{`${quantity}${QUANTITY_SYMBOL}`}</Typography>
            </Box>
          </Box>
          <Box className={classes.productFixFlexContainer}>
            <Box>
              <Typography variant="body2" align="right" className={classes.textSpace}>
                {t('shop.order-history.product-price-label')}
              </Typography>
              <Typography variant="h3" align="right">
                {formattedPrice}
              </Typography>
            </Box>
          </Box>
        </Box>
        {subProducts.length > 0 && <OrderHistorySubProducts subProducts={subProducts} configuratorQuantity={quantity} />}
      </Card>
    </Box>
  )
}

export default OrderHistoryProducts
